import {object, string} from 'yup'

export const SuperAdminSchema = object().shape({
  firstName: string().max(255, 'First name too long!').required('First name is required!'),
  lastName: string().max(512, 'Last name too long!').required('Last name is required!'),
  email: string().email('Invalid or unsupported email format!').required('Email is required!')
})
